import isChromatic from "chromatic/isChromatic";

/**
 * Method for checking whether it's safe to run animations.
 */
export default function shouldNotAnimate() {
  // Check if we're in the context of chromatic rendering the component to take a visual snapshot.
  // https://www.chromatic.com/docs/animations#javascript-animations
  const inChromatic = isChromatic();
  const inTestOrCIEnvironment =
    process.env.NODE_ENV === "test" || process.env.TEST_ENV === "ci";

  // Check if the user has the prefers reduced animation operating system setting turned on.
  const reducedMotionMediaQuery = window.matchMedia(
    "(prefers-reduced-motion: reduce)",
  );

  // Check if the user's system doesn't give them the option to opt out of animations.
  const noReducedMotionSetting = !reducedMotionMediaQuery;
  return (
    inChromatic ||
    inTestOrCIEnvironment ||
    reducedMotionMediaQuery.matches ||
    noReducedMotionSetting
  );
}
